import React from 'react'

const StartingPage = () => {


    return (
        <div className='conatiner-fluid' style={{ width: '95%', margin: 'auto', fontSize: '1.3rem' }}>
            <div className='row'>
                <div className='col-8' style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    margin: '7.8vh auto'

                }}>
                    <img src='../images/s3.jpg' className='img-fluid' />
                    <div style={{ textAlign: 'center' }}>
                        -------------- welcome to all on my <span style={{ color: 'red' }}>food delevery</span> website &nbsp;--------------
                        <br />
                        <marquee width="100%" behavior="alternate" scrollamount='10' scrdirection="left" height="auto" style={{ color: 'blue', marginTop: '1rem' }}>
                            order now and get discount
                        </marquee>
                        <br />
                        <marquee width="100%" behavior="alternate" scrollamount='6' scrdirection="right" height="auto" style={{ color: 'darkgreen', marginTop: '1rem' }}>
                            ❤️❤️ Harikeshmaurya9984@gmail.com ❤️❤️
                        </marquee>
                    </div>



                </div>
            </div>
        </div>
    )
}

export default StartingPage;